export class RankingCategoryItem {
  public code: string;
  protected _isTeam: boolean;
  public name: string;
  public pro: boolean;
  constructor(rawRankingItem: any, categoryName: string = "") {
    if (rawRankingItem.Name) {
      categoryName = rawRankingItem.Name;
    }
    this.code = rawRankingItem.Cat;
    this._isTeam = rawRankingItem.Team;
    this.name = categoryName;
    this.pro = rawRankingItem.Pro;
  }

  get isTeam(): boolean {
    return this._isTeam;
  }
}
